module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lepus/lep_lines-b8cb9cd0bc778a7b06bd90c6ae60a2e6.gif";